(function(){
  var pEl=document.getElementById('pbo-product');
  var cEl=document.getElementById('cso-config');
  if(!pEl||!cEl)return;
  var P=JSON.parse(pEl.textContent);
  var CFG=JSON.parse(cEl.textContent);
  var L=CFG.labels||{};
  var FBT=CFG.fbt||null;
  var AKIL=(CFG.akilliEsler&&CFG.akilliEsler.urunler)||{};
  var poolCache={},prodCache={},MY=null,PICK=null,PICK_VARIANT=null;
  /* Matris v2.1: partner girdisi temsilci rengi (handle) tasir; ust duzey 'kardes' haritasi
     temsilci -> modelin diger stoktaki renkleri. Temsilcide beden yoksa kardesler sirayla denenir. */
  var KARDES=(CFG.akilliEsler&&CFG.akilliEsler.kardes)||{};
  var stripDone=false,fbtDone=false,fbtBusy=false;

  function money(c){return (c/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})+' ₺';}
  function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/\"/g,'&quot;');}
  function norm(s){return String(s||'').toLowerCase().trim();}
  function trFold(s){return norm(s).replace(/ş/g,'s').replace(/ı/g,'i').replace(/ğ/g,'g').replace(/ü/g,'u').replace(/ö/g,'o').replace(/ç/g,'c');}
  function family(t){return norm(String(t||'').split('|')[0]);}

  /* --- OGRENEN KATMAN yardimcilari ---------------------------------------
     gezilenler: cihaz ici son gezilen urunler (kisisel veri yok, localStorage)
     abKova: ziyaretci kalici olarak 0/1 kovasina atanir -> aday rotasyonu
     (kesif/испат dengesi); siparis atfi (_oneri) hangi adayin kazandigini soyler. */
  function gezilenler(){try{return JSON.parse(localStorage.getItem('pa_gezilen')||'[]');}catch(e){return [];}}
  try{
    var _g=gezilenler().filter(function(x){return x!==P.id;});
    _g.unshift(P.id);
    localStorage.setItem('pa_gezilen',JSON.stringify(_g.slice(0,20)));
  }catch(e){}
  function abKova(){
    try{
      var k=localStorage.getItem('pa_kova');
      if(k!=='0'&&k!=='1'){k=Math.random()<0.5?'0':'1';localStorage.setItem('pa_kova',k);}
      return k;
    }catch(e){return '0';}
  }
  function renkim(){var p=String(P.title||'').split('|');return p.length>1?trFold(p[p.length-1]).replace(/\s+/g,'-'):'';}

  /* Aday siralamasi: birliktelik skoru (90g gercek siparisler) > renk uyumu >
     yakin zamanda gezilme. Ardindan kova-1 ziyaretcilerde ilk iki aday yer
     degistirir (rotasyon) -> adaylar adil trafik alir, atif kazanani secer. */
  function siralaAdaylar(handles,ids){
    var kayit=AKIL[String(P.id)];
    var akil=(kayit&&kayit.esler)||[];
    var akilSira={};
    akil.forEach(function(e,i){akilSira[e.handle]={i:i,sayi:e.sayi||0,fiyat:e.fiyat||0};});
    var bf=(P.price||0)/100; /* kaynak urun fiyati (TL) */
    var gez=gezilenler();
    var rk=renkim();
    var puanli=handles.map(function(h,idx){
      var puan=0;
      var a=akilSira[h];
      if(a)puan+=100-(a.i*15)+Math.min(a.sayi,20);
      /* K6: renk uyumu ikincil sinyal (+25 -> +10). Matris v2 sayilari 3-12 araliginda,
         bir sira adimi 15; +25 sirayi eziyordu. */
      if(rk&&String(h).indexOf(rk)!==-1)puan+=10;
      /* K7 (YUMUSAK): fiyat bandi (%60-140) disindaki partner elenmez, -10 ceza alir.
         Sert bant organik ust<->alt ciftlerinin ~yarisini siliyordu. */
      if(a&&a.fiyat&&bf&&(a.fiyat<bf*0.6||a.fiyat>bf*1.4))puan-=10;
      var pid=ids&&ids[idx];
      if(pid&&gez.indexOf(pid)!==-1)puan+=15;
      return {h:h,puan:puan,idx:idx};
    });
    puanli.sort(function(a,b){return b.puan-a.puan||a.idx-b.idx;});
    if(puanli.length>1&&abKova()==='1'){var t=puanli[0];puanli[0]=puanli[1];puanli[1]=t;}
    return puanli.map(function(x){return x.h;});
  }

  /* Soguk baslangic yedegi: birliktelik verisi olmayan urunlerde es kaynagi
     Shopify'in oneri motorudur (satin alma gecmisi + aciklama + koleksiyon
     benzerligi). Once complementary (magaza kurgusu), bos donerse related.
     Indirim iddiasi yok; atif icin _oneri:'shopify-oneri' tasinir. */
  var SHOPIFY_ONERI_BEKLIYOR=false;
  function shopifyOneriYukle(){
    SHOPIFY_ONERI_BEKLIYOR=true;
    var iste=function(intent,cb){
      fetch('/recommendations/products.json?product_id='+P.id+'&limit=10&intent='+intent)
        .then(function(r){return r.ok?r.json():{products:[]};})
        .then(function(j){cb((j&&j.products)||[]);})
        .catch(function(){cb([]);});
    };
    var sec=function(list){
      var adaylar=(list||[]).filter(function(p){
        return p&&p.id!==P.id&&String(p.handle||'').indexOf('zz-')!==0&&p.available!==false;
      });
      if(!adaylar.length)return false;
      OFR={id:'shopify-oneri',rozet:'BİRLİKTE AL',pct:ONERI_PCT,tetikleme:'paket_akisi',akilli:true};
      OFR_PARTNER_HANDLES=siralaAdaylar(
        adaylar.map(function(p){return p.handle;}),
        adaylar.map(function(p){return p.id;})
      );
      return true;
    };
    iste('complementary',function(cs){
      var oldu=false;
      try{oldu=sec(cs);}catch(e){}
      if(oldu){SHOPIFY_ONERI_BEKLIYOR=false;renderFbt();return;}
      iste('related',function(rs){
        try{sec(rs);}catch(e){}
        SHOPIFY_ONERI_BEKLIYOR=false;
        renderFbt();
      });
    });
  }

  /* Kural esles(mesi): urun bir ikili_set kuralindaysa o kural; degilse
     birliktelik matrisi varsa VERI-DESTEKLI oneri (indirim iddiasi YOK). */
  /* Kuralsiz (akilli/Shopify) onerilerin yuzdesi motordaki "oneri" tipli
     kuraldan gelir; kural yoksa kart indirimsiz gosterilir. */
  var ONERI_KURAL=(CFG.oneriKurali||null);
  var ONERI_PCT=ONERI_KURAL?(ONERI_KURAL.pct||0):0;
  var ONERI_ID=ONERI_KURAL?ONERI_KURAL.id:'akilli-oneri';

  var OFR=null,OFR_PARTNER_HANDLES=[],OFR_PARTNER_IDS=[];
  (CFG.oneriler||[]).some(function(o){
    var aIds=o.aIds||[],bIds=o.bIds||[];
    if(aIds.indexOf(P.id)!==-1){OFR=o;OFR_PARTNER_HANDLES=(o.bHandles||[]).filter(Boolean);OFR_PARTNER_IDS=bIds;return true;}
    if(bIds.indexOf(P.id)!==-1){OFR=o;OFR_PARTNER_HANDLES=(o.aHandles||[]).filter(Boolean);OFR_PARTNER_IDS=aIds;return true;}
    return false;
  });
  if(OFR){
    OFR_PARTNER_HANDLES=siralaAdaylar(OFR_PARTNER_HANDLES,OFR_PARTNER_IDS);
  }else{
    var akKayit=AKIL[String(P.id)];
    if(akKayit&&akKayit.esler&&akKayit.esler.length){
      OFR={id:'akilli-es',rozet:'BİRLİKTE AL',pct:ONERI_PCT,tetikleme:'paket_akisi',akilli:true};
      OFR_PARTNER_HANDLES=siralaAdaylar(
        akKayit.esler.map(function(e){return e.handle;}),
        akKayit.esler.map(function(e){return e.id;})
      );
    }else{
      shopifyOneriYukle();
    }
  }


  function track(ev,p){
    p=p||{};
    try{if(window.gtag){window.gtag('event',ev,p);}else if(window.dataLayer){var o={event:ev};for(var k in p){o[k]=p[k];}window.dataLayer.push(o);}}catch(e){}
    try{if(window.fbq){window.fbq('trackCustom',ev,p);}}catch(e){}
  }

  /* Sepete ekleme sonrasi: /cart'a yonlendirmek yerine yan cekmece (quick-cart).
     Eski yontem bos sepette calismiyordu (adet kutusu yok -> false -> /cart'a git).
     Yeni yontem temanin resmi uygulama kancasi: "apps:product-added-to-cart" ->
     Stiletto header sayacini gunceller + refreshQuickCart() ile cekmeceyi sunucudan
     yeniler; ardindan header sepet ikonuna tiklanir -> tema "quick-cart:open" yayinlar.
     Ayni desen kombin-cart.js ve pa-hediye-barem.js'de kanitli. */
  function refreshAndShowCart(){
    if(location.pathname.indexOf('/cart')===0){
      var inp=document.querySelector('.cart__form-item .quantity-input__input');
      if(!inp)return false;
      inp.dispatchEvent(new Event('change',{bubbles:true}));
      return true;
    }
    if(!document.querySelector('.quick-cart'))return false;
    try{document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));}catch(e){return false;}
    setTimeout(function(){
      var trig=document.querySelector('header a[href=\"/cart\"], .header a[href=\"/cart\"], [data-quick-cart-trigger]');
      if(trig)trig.click();
    },350);
    return true;
  }

  function loadCol(h){
    if(poolCache[h])return Promise.resolve(poolCache[h]);
    return fetch('/collections/'+h+'/products.json?limit=50',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():{products:[]};})
      .then(function(d){poolCache[h]=d.products||[];return poolCache[h];})
      .catch(function(){poolCache[h]=[];return [];});
  }
  function loadProd(h){
    if(prodCache[h])return Promise.resolve(prodCache[h]);
    return fetch('/products/'+h+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():null;})
      .then(function(d){
        if(!d){prodCache[h]=null;return null;}
        var p={id:d.id,title:d.title,handle:d.handle,
          images:[{src:(d.images&&d.images[0])||d.featured_image||''}],
          variants:(d.variants||[]).map(function(v){
            return {id:v.id,title:v.title,price:(v.price/100).toFixed(2),available:v.available};
          })};
        prodCache[h]=p;return p;
      }).catch(function(){prodCache[h]=null;return null;});
  }
  function variantsOf(p){
    return (p.variants||[]).map(function(v){
      return {id:v.id,title:v.title,price:Math.round(parseFloat(v.price)*100),avail:v.available!==false};
    });
  }
  function minPrice(p){
    var vs=variantsOf(p).filter(function(v){return v.avail;});
    return vs.length?vs.reduce(function(a,v){return Math.min(a,v.price);},Infinity):null;
  }
  function loadMine(){
    if(MY)return Promise.resolve(MY);
    return fetch('/products/'+P.handle+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(d){
        MY={map:{},list:[]};
        (d.variants||[]).forEach(function(v){
          MY.map[v.id]={price:v.price,avail:v.available,title:v.title};
          MY.list.push({id:v.id,title:v.title,price:v.price,avail:v.available});
        });
        return MY;
      }).catch(function(){MY={map:{},list:[]};return MY;});
  }
  function themeVariantId(){
    var f=document.querySelector('form.product-form [name=\"id\"]');
    var v=f?parseInt(f.value,10):NaN;
    return isNaN(v)?null:v;
  }
  /* --- Beden eslesmesi: musterinin PDP'de sectigi beden partnerde stokta mi? --- */
  function bedenAdi(t){t=String(t||'');var i=t.lastIndexOf(' / ');return i===-1?'':t.slice(i+3).trim();}
  function benimBeden(){var tv=themeVariantId();if(tv&&MY&&MY.map[tv])return bedenAdi(MY.map[tv].title);return '';}
  /* Donus: eslesen stoktaki varyant id'si; bedensiz urunde (sapka) ilk stoktaki; yoksa null */
  function bedenEsle(p,beden){
    var vs=variantsOf(p),av=vs.filter(function(v){return v.avail;});
    if(!av.length)return null;
    if(!beden)return av[0].id;
    var bedensiz=vs.every(function(v){return bedenAdi(v.title)==='';});
    if(bedensiz)return av[0].id;
    var b=beden.toLowerCase();
    for(var i=0;i<av.length;i++){if(bedenAdi(av[i].title).toLowerCase()===b)return av[i].id;}
    return null;
  }
  function myPriceNow(){
    var tv=themeVariantId();
    if(tv&&MY&&MY.map[tv])return MY.map[tv].price;
    var ilk=(MY&&MY.list||[]).filter(function(v){return v.avail;})[0];
    return ilk?ilk.price:0;
  }

  /* ---------- 1) bundle strip ---------- */
  function findBundle(){
    var list=CFG.bundles||[],t=norm(P.type),fallback=null;
    for(var i=0;i<list.length;i++){
      var b=list[i];
      if(b.handle===P.handle)continue;
      var ids=b.productIds||[];
      if(ids.length){
        if(ids.indexOf(P.id)!==-1)return b;
        continue;
      }
      if(!fallback&&(b.types||[]).map(norm).indexOf(t)!==-1)fallback=b;
    }
    return fallback;
  }

  function savingOf(b){
    if(!b.cap||!b.price||b.cap<=b.price)return null;
    var save=b.cap-b.price;
    return {save:save,pct:Math.round(save/b.cap*100)};
  }

  function renderStrip(){
    if(stripDone)return;
    var b=findBundle();
    if(!b)return;
    var anchor=document.querySelector('.product-form__controls-group--submit');
    if(!anchor)return;
    stripDone=true;

    var sv=savingOf(b);
    var detail;
    if(sv){
      detail='<span class=\"pbo-save\">%'+sv.pct+' indirim · '+money(sv.save)+' tasarruf</span>';
    }else if(typeof b.defSave==='number'&&b.defSave>0){
      detail='<span class=\"pbo-save\">%'+(b.defPct||0)+' indirim · '+money(b.defSave)+' tasarruf</span>';
    }else{
      var best=null;
      (b.tiers||[]).forEach(function(x){if(typeof x.pct==='number'&&(!best||x.pct>best))best=x.pct;});
      var line=b.line&&b.line.length?b.line:(best?('%'+best+"'e varan indirim"):(L.bundleFallback||''));
      detail='<p class=\"pbo-line\">'+esc(line)+'</p>';
    }

    var a=document.createElement('a');
    a.className='pbo-strip';
    a.href='/products/'+b.handle;
    a.setAttribute('data-pbo-strip',b.handle);
    a.innerHTML='<img src=\"'+esc(b.img||'')+'\" alt=\"'+esc(b.title)+'\" loading=\"lazy\">'+
      '<span class=\"pbo-strip-body\">'+
        '<span class=\"pbo-tag\">'+esc(L.bundleTag||'PAKET AVANTAJI')+'</span>'+
        '<p class=\"pbo-title\">'+esc(b.title)+'</p>'+
        detail+
      '</span><span class=\"pbo-go\">'+esc(L.view||'İncele')+'</span>';
    anchor.parentNode.insertBefore(a,anchor);
    track('bundle_strip_view',{bundle_id:b.handle,source_product:P.handle,save:sv?sv.save/100:(b.defSave||0)/100,pct:sv?sv.pct:(b.defPct||0)});
  }

  /* ---------- 2) Bundle onerisi / akilli oneri: KOMPAKT KART ---------- */
  function optionsHtml(list,selId){
    return list.map(function(v){
      return '<option value=\"'+v.id+'\"'+(v.id===selId?' selected':'')+(v.avail?'':' disabled')+'>'+
        esc(v.title)+(v.avail?'':' — tükendi')+'</option>';
    }).join('');
  }

  function setChipGuncelle(){
    var box=document.querySelector('[data-pbo-set]');
    if(!box||!OFR||!PICK)return;
    var sel=box.querySelector('[data-set-sel]');
    var pid=sel?parseInt(sel.value,10):null;
    var pFiyat=0;
    variantsOf(PICK).forEach(function(v){if(v.id===pid)pFiyat=v.price;});
    var toplam=myPriceNow()+pFiyat;
    var tasarruf=Math.round(toplam*(OFR.pct||0)/100);
    var sEl=box.querySelector('[data-set-save]');
    if(sEl){
      if(OFR.pct>0){
        sEl.style.display='';
        sEl.textContent='Kazancın '+money(tasarruf);
      }else{
        sEl.style.display='none';
      }
    }
    var tEl=box.querySelector('[data-set-total]');
    if(tEl){
      /* Etiket + fiyat cifti ayri span: cift (indirimli + ustu cizili) hicbir zaman bolunmez;
         dar ekranda sigmazsa cift olarak etiketin ALTINA iner. */
      tEl.innerHTML='<span class=\"pbo-set-total-lbl\">Birlikte Toplam:</span> '+(OFR.pct>0
        ?'<span class=\"pbo-set-total-fiyat\"><b>'+money(toplam-tasarruf)+'</b> <s>'+money(toplam)+'</s></span>'
        :'<span class=\"pbo-set-total-fiyat\"><b>'+money(toplam)+'</b></span>');
    }
  }

  /* Buyuk harf: metin ASCII ise duz toUpperCase ("Ribbed"->"RIBBED"),
     Turkce karakter iceriyorsa tr-TR ("Sıklıkla"->"SIKLIKLA"). Karisik
     locale, Ingilizce adlarda "RİBBED" gibi hatali I'lere yol aciyordu. */
  function buyuk(s){
    s=String(s||'');
    return /^[\x00-\x7F]*$/.test(s)?s.toUpperCase():s.toLocaleUpperCase('tr-TR');
  }

  /* Buton etiketi: masaustunde tek satir "BİRLİKTE SEPETE EKLE", mobilde CSS ilk
     parcayi block yapar -> "BİRLİKTE" / "SEPETE EKLE" iki satir. Buyuk harf
     literal (buyuk() tuzagi: ASCII yolunda noktasiz I cikardi). */
  var SET_BTN_HTML='<span class=\"pbo-btn-satir\">BİRLİKTE</span> <span class=\"pbo-btn-satir\">SEPETE EKLE</span>';
  function renderSet(){
    var anchor=document.querySelector('.product-form__controls-group--submit');
    if(!anchor)return false;
    var thVars=variantsOf(PICK);
    var thAvail=thVars.filter(function(v){return v.avail;});
    if(!thAvail.length)return false;
    var thSel=(PICK_VARIANT&&thAvail.some(function(v){return v.id===PICK_VARIANT;}))?PICK_VARIANT:thAvail[0].id;
    var img=(PICK.images&&PICK.images[0]&&PICK.images[0].src)||'';

    /* Kart zaten varsa (beden degisince yeniden secim) ayni kutuyu YERINDE doldur:
       kaldirip yeniden yaratmak sayfayi ziplatiyordu. */
    var box=document.querySelector('[data-pbo-set]');
    var yeniKutu=!box;
    if(yeniKutu){
      box=document.createElement('div');
      box.className='pbo-set';
      box.setAttribute('data-pbo-set','');
      box.style.position='relative';
    }
    var rozet=OFR.tetikleme==='paket_akisi'
      ?'<span class=\"pbo-set-ozel\">SANA ÖZEL</span>'
      :'';
    box.innerHTML=rozet+
      '<span class=\"pbo-set-satir\">'+
        '<img class=\"pbo-set-img\" src=\"'+esc(P.img||'')+'\" alt=\"'+esc(P.title)+'\" loading=\"lazy\">'+
        '<span class=\"pbo-set-satir-govde\">'+
          '<span class=\"pbo-tag\">BİRLİKTE AL</span>'+
          '<p class=\"pbo-title\">'+esc(P.title)+'</p>'+
        '</span>'+
      '</span>'+
      '<span class=\"pbo-set-arti\">+</span>'+
      '<span class=\"pbo-set-satir\">'+
        '<a href=\"/products/'+esc(PICK.handle)+'\"><img class=\"pbo-set-img\" src=\"'+esc(img)+'\" alt=\"'+esc(PICK.title)+'\" loading=\"lazy\"></a>'+
        '<span class=\"pbo-set-satir-govde\">'+
          '<p class=\"pbo-title\"><a class=\"pbo-set-lnk\" href=\"/products/'+esc(PICK.handle)+'\">'+esc(PICK.title)+'</a></p>'+
          '<select class=\"pbo-set-sel\" data-set-sel>'+optionsHtml(thVars,thSel)+'</select>'+
        '</span>'+
      '</span>'+
      '<span class=\"pbo-set-alt\">'+
        '<span class=\"pbo-set-fiyatlar\">'+
          '<span class=\"pbo-set-total\" data-set-total></span>'+
          '<span class=\"pbo-save\" data-set-save></span>'+
        '</span>'+
        '<button type=\"button\" class=\"pbo-set-btn pbo-set-btn--buyuk\" data-set-add>'+SET_BTN_HTML+'</button>'+
      '</span>'+
      '<p class=\"pbo-set-hint\" data-set-hint></p>';
    if(yeniKutu){
      var yer=anchor.parentNode.querySelector('.pa-pay');
      if(yer){yer.parentNode.insertBefore(box,yer.nextSibling);}
      else{anchor.parentNode.insertBefore(box,anchor.nextSibling);}
    }else{
      box.classList.remove('pbo-set--yenileniyor');
    }
    setChipGuncelle();
    return true;
  }

  function fbtPriceOf(which){
    var box=document.querySelector('.fbt');
    if(!box)return 0;
    var sel=box.querySelector('[data-fbt-sel=\"'+which+'\"]');
    var id=sel?parseInt(sel.value,10):null;
    if(which==='mine')return (MY&&MY.map[id])?MY.map[id].price:0;
    var vs=variantsOf(PICK);
    for(var i=0;i<vs.length;i++){if(vs[i].id===id)return vs[i].price;}
    return 0;
  }
  function fbtPaintTotals(){
    var box=document.querySelector('.fbt');
    if(!box||!FBT)return;
    var sum=fbtPriceOf('mine')+fbtPriceOf('theirs');
    var fin=Math.round(sum*(100-(FBT.pct||0))/100);
    box.querySelector('[data-fbt-total]').innerHTML='Toplam Fiyat: <b>'+money(fin)+'</b> <s>'+money(sum)+'</s>';
    var sv=box.querySelector('[data-fbt-save]');
    if(sum>fin){sv.hidden=false;sv.textContent='Kazancınız: '+money(sum-fin);}else{sv.hidden=true;}
  }

  function renderFbtBox(){
    var anchor=document.querySelector('.pa-pay')||document.querySelector('.product-form__controls-group--submit');
    if(!anchor)return false;
    var myAvail=MY.list.filter(function(v){return v.avail;});
    var mySel=themeVariantId()||(myAvail[0]&&myAvail[0].id)||MY.list[0].id;
    var thVars=variantsOf(PICK);
    var thAvail=thVars.filter(function(v){return v.avail;});
    if(!thAvail.length)return false;
    var thSel=thAvail[0].id;

    var box=document.createElement('div');
    box.className='fbt';
    box.innerHTML=
      '<p class=\"fbt-head\">'+esc(FBT.heading||'En Sık Birlikte Alınan')+'</p>'+
      '<div class=\"fbt-pair\">'+
        '<div class=\"fbt-item\">'+
          '<img src=\"'+esc(P.img||'')+'\" alt=\"'+esc(P.title)+'\">'+
          '<p class=\"fbt-name\">'+esc(P.title)+'</p>'+
          '<div class=\"fbt-price\" data-fbt-p=\"mine\"></div>'+
          '<select class=\"fbt-sel\" data-fbt-sel=\"mine\">'+optionsHtml(MY.list,mySel)+'</select>'+
        '</div>'+
        '<div class=\"fbt-plus\">+</div>'+
        '<div class=\"fbt-item\">'+
          '<a href=\"/products/'+esc(PICK.handle)+'\"><img src=\"'+esc((PICK.images&&PICK.images[0]&&PICK.images[0].src)||'')+'\" alt=\"'+esc(PICK.title)+'\" loading=\"lazy\"></a>'+
          '<p class=\"fbt-name\"><a href=\"/products/'+esc(PICK.handle)+'\">'+esc(PICK.title)+'</a></p>'+
          '<div class=\"fbt-price\" data-fbt-p=\"theirs\"></div>'+
          '<select class=\"fbt-sel\" data-fbt-sel=\"theirs\">'+optionsHtml(thVars,thSel)+'</select>'+
        '</div>'+
      '</div>'+
      '<div class=\"fbt-total\" data-fbt-total></div>'+
      '<div style=\"text-align:center\"><span class=\"fbt-save\" data-fbt-save hidden></span></div>'+
      '<button type=\"button\" class=\"fbt-btn\" data-fbt-add>'+esc(FBT.button||'Paketi Sepete Ekle')+'</button>'+
      '<p class=\"fbt-hint\" data-fbt-hint></p>';
    var fyer=anchor.parentNode.querySelector('.pa-pay');
    if(fyer){fyer.parentNode.insertBefore(box,fyer.nextSibling);}
    else{anchor.parentNode.insertBefore(box,anchor.nextSibling);}
    box.querySelector('[data-fbt-p=\"mine\"]').textContent=money(fbtPriceOf('mine'));
    box.querySelector('[data-fbt-p=\"theirs\"]').textContent=money(fbtPriceOf('theirs'));
    fbtPaintTotals();
    return true;
  }

  function renderFbt(){
    if(fbtDone||fbtBusy)return;

    if(OFR&&OFR_PARTNER_HANDLES.length){
      fbtBusy=true;
      /* Adaylar GRUP halinde: [temsilci renk, renk kardesleri...]. Siralama: 1. grubun tum
         renkleri, sonra 2. grup... Ilk gecen: musterinin sectigi beden stokta olan aday.
         Hicbirinde beden yoksa YEDEK: stokta herhangi bir varyanti olan ilk aday. */
      var gruplar=OFR_PARTNER_HANDLES.map(function(h){return [h].concat(KARDES[h]||[]);});
      loadMine().then(function(){
        if(!MY.list.length){fbtBusy=false;fbtDone=true;return;}
        var beden=benimBeden();
        var yedek=null,gi=0,hi=0,eslesti=0;
        var bitir=function(){
          fbtDone=renderSet();
          fbtBusy=false;
          if(fbtDone)track('oneri_view',{oneri_id:OFR.id,source_product:P.handle,product:PICK.handle,pct:OFR.pct,akilli:OFR.akilli?1:0,kova:abKova(),beden_eslesti:eslesti});
        };
        var dene=function(){
          if(gi>=gruplar.length){
            if(yedek){PICK=yedek.p;PICK_VARIANT=yedek.vid;eslesti=0;bitir();}
            else{fbtBusy=false;fbtDone=true;}
            return;
          }
          var grup=gruplar[gi];
          if(hi>=grup.length){gi++;hi=0;dene();return;}
          var h=grup[hi++];
          loadProd(h).then(function(p){
            if(!p||minPrice(p)===null){dene();return;}
            var vid=bedenEsle(p,beden);
            if(vid){PICK=p;PICK_VARIANT=vid;eslesti=beden?1:0;bitir();return;}
            if(!yedek){var av=variantsOf(p).filter(function(v){return v.avail;})[0];yedek={p:p,vid:av?av.id:null};}
            dene();
          });
        };
        dene();
      });
      return;
    }

    if(SHOPIFY_ONERI_BEKLIYOR)return;
    if(!FBT||!FBT.collection)return;
    fbtBusy=true;
    Promise.all([loadCol(FBT.collection),loadMine()]).then(function(res){
      var scope=res[0];
      var inScope=false;
      for(var i=0;i<scope.length;i++){if(scope[i].id===P.id){inScope=true;break;}}
      if(!inScope){fbtBusy=false;fbtDone=true;return;}
      var myFam=family(P.title);
      for(var j=0;j<scope.length;j++){
        var c=scope[j];
        if(c.id===P.id)continue;
        if(family(c.title)===myFam)continue;
        if(minPrice(c)===null)continue;
        PICK=c;break;
      }
      if(!PICK||!MY.list.length){fbtBusy=false;return;}
      fbtDone=renderFbtBox();
      fbtBusy=false;
      if(fbtDone)track('fbt_view',{source_product:P.handle,product:PICK.handle,pct:FBT.pct});
    }).catch(function(){fbtBusy=false;});
  }

  function syncMine(){
    /* PDP'de beden degisti: partnerde ayni beden stoktaysa secimi oraya cek */
    var kart=document.querySelector('[data-pbo-set]');
    if(kart&&PICK){
      var psel=kart.querySelector('[data-set-sel]');
      var vid=bedenEsle(PICK,benimBeden());
      if(vid){
        if(psel&&psel.value!==String(vid))psel.value=String(vid);
      }else if(OFR&&OFR_PARTNER_HANDLES.length&&!fbtBusy){
        /* Partnerde bu beden YOK: karti kaldir, adaylari yeni bedenle bastan gez
           (kardes renk -> sonraki partner -> yedek). Urun verisi prodCache'te, ucuz. */
        kart.classList.add('pbo-set--yenileniyor'); /* kart yerinde kalir, hafif solar */
        fbtDone=false;PICK=null;PICK_VARIANT=null;
        renderFbt();
        return;
      }
    }
    setChipGuncelle();
    var box=document.querySelector('.fbt');
    if(!box)return;
    var sel=box.querySelector('[data-fbt-sel=\"mine\"]');
    var tv=themeVariantId();
    if(sel&&tv&&sel.value!=String(tv))sel.value=String(tv);
    box.querySelector('[data-fbt-p=\"mine\"]').textContent=money(fbtPriceOf('mine'));
    fbtPaintTotals();
  }

  document.addEventListener('change',function(ev){
    if(!ev.target.closest)return;
    if(ev.target.closest('[data-set-sel]')){setChipGuncelle();return;}
    if(ev.target.closest('[data-fbt-sel]')){
      var box=document.querySelector('.fbt');
      box.querySelector('[data-fbt-p=\"mine\"]').textContent=money(fbtPriceOf('mine'));
      box.querySelector('[data-fbt-p=\"theirs\"]').textContent=money(fbtPriceOf('theirs'));
      fbtPaintTotals();
      return;
    }
    if(ev.target.closest('form.product-form'))setTimeout(syncMine,80);
  });

  document.addEventListener('click',function(ev){
    if(!ev.target.closest)return;

    var strip=ev.target.closest('[data-pbo-strip]');
    if(strip){track('bundle_strip_click',{bundle_id:strip.getAttribute('data-pbo-strip'),source_product:P.handle});return;}

    if(ev.target.closest('form.product-form'))setTimeout(syncMine,140);

    var setAdd=ev.target.closest('[data-set-add]');
    if(setAdd){
      var kart=document.querySelector('[data-pbo-set]');
      var ipucu=kart.querySelector('[data-set-hint]');
      var benim=themeVariantId();
      if(!benim||!(MY.map[benim]&&MY.map[benim].avail)){
        var ilkUygun=MY.list.filter(function(v){return v.avail;})[0];
        benim=ilkUygun?ilkUygun.id:null;
      }
      var partner=parseInt(kart.querySelector('[data-set-sel]').value,10);
      if(!benim||!partner){ipucu.textContent='Lütfen beden seçin.';return;}
      setAdd.disabled=true;setAdd.textContent='EKLENİYOR...';
      /* Akilli (kuralsiz) oneri: indirim iddiasi yok -> _paket etiketi YOK;
         atif icin yalniz _oneri tasinir. Kurallilarda ikisi de tasinir. */
      var props=OFR.akilli?{_oneri:OFR.id,_paket:ONERI_ID,_kova:abKova()}:{_oneri:OFR.id,_paket:OFR.id,_kova:abKova()};
      track('oneri_add',{oneri_id:OFR.id,source_product:P.handle,product:PICK.handle,pct:OFR.pct,akilli:OFR.akilli?1:0,kova:abKova()});
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:benim,quantity:1,properties:props},{id:partner,quantity:1,properties:props}]})})
        .then(function(r){if(!r.ok)throw new Error('add');return r.json();})
        .then(function(){
          setAdd.disabled=false;setAdd.innerHTML=SET_BTN_HTML;
          if(!refreshAndShowCart())location.href='/cart';
        })
        .catch(function(){
          setAdd.disabled=false;setAdd.innerHTML=SET_BTN_HTML;
          ipucu.textContent='Eklenemedi, tekrar deneyin.';
        });
      return;
    }

    var add=ev.target.closest('[data-fbt-add]');
    if(!add)return;
    var box2=document.querySelector('.fbt');
    var hint=box2.querySelector('[data-fbt-hint]');
    var a=parseInt(box2.querySelector('[data-fbt-sel=\"mine\"]').value,10);
    var b=parseInt(box2.querySelector('[data-fbt-sel=\"theirs\"]').value,10);
    if(!a||!b){hint.textContent='Lütfen iki ürün için de beden seçin.';return;}
    if(MY.map[a]&&!MY.map[a].avail){hint.textContent='Seçtiğiniz beden tükendi.';return;}
    add.disabled=true;add.textContent='EKLENİYOR...';
    track('fbt_add',{source_product:P.handle,product:PICK.handle,pct:FBT.pct});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:a,quantity:1,properties:{_fbt:'1'}},{id:b,quantity:1,properties:{_fbt:'1'}}]})})
      .then(function(r){if(!r.ok)throw new Error('add');return r.json();})
      .then(function(){
        add.disabled=false;add.textContent=FBT.button||'Paketi Sepete Ekle';
        if(!refreshAndShowCart())location.href='/cart';
      })
      .catch(function(){
        add.disabled=false;add.textContent=FBT.button||'Paketi Sepete Ekle';
        hint.textContent='Eklenemedi, tekrar deneyin.';
      });
  });

  /* BEDEN DEGISIMI IZLEYICISI: Stiletto beden secicisi ([name^="options"]) gizli
     [name="id"] select'ini kendi yontemiyle guncelliyor; form 'change' olayi karta
     ulasmiyordu (kart ancak icine tiklaninca yenileniyordu). 300 ms'de bir secili
     varyanti karsilastir; degistiyse syncMine -> partner bedeni / yeniden secim. */
  var SON_VARYANT=null;
  setInterval(function(){
    var tv=themeVariantId();
    if(!tv||tv===SON_VARYANT)return;
    var ilk=SON_VARYANT===null;
    SON_VARYANT=tv;
    if(!ilk)syncMine();
  },300);
  document.addEventListener('change',function(ev){
    var n=ev.target&&ev.target.name;
    if(n&&/^options/.test(n))setTimeout(syncMine,120);
  });

  function run(){renderStrip();renderFbt();}
  var t=null;
  var mo=new MutationObserver(function(){
    if(stripDone&&fbtDone)return;
    clearTimeout(t);t=setTimeout(run,250);
  });
  mo.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('DOMContentLoaded',run);
  run();
})();
